export enum LandingPageButton {
    InfoTextButton = "InfoTextButton",
    PearchLogo = "PearchLogo"
}